module.exports = __webpack_public_path__ + "img/i_page.382b2d8d.png";